module.exports = __webpack_public_path__ + "img/nye-2024.a0fdb887.jpg";